import React from 'react';
export function PartnersSection() {
  const partners = [{
    name: 'IBM Cloud',
    highlight: true
  }, {
    name: 'AWS',
    highlight: false
  }, {
    name: 'Microsoft Azure',
    highlight: false
  }, {
    name: 'Google Cloud',
    highlight: false
  }, {
    name: 'NVIDIA',
    highlight: false
  }];
  return <section id="partners" className="py-16 bg-ucensys-navy border-y border-border-color overflow-hidden" data-id="element-275">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-276">
        <div className="text-center mb-10" data-id="element-277">
          <h3 className="text-sm font-heading font-bold text-text-secondary uppercase tracking-widest mb-2" data-id="element-278">
            Trusted Technology Partners
          </h3>
          <p className="text-text-muted font-body text-sm" data-id="element-279">
            Seamlessly integrate with your existing cloud providers
          </p>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16 opacity-70 grayscale hover:grayscale-0 transition-all duration-500" data-id="element-280">
          {partners.map((partner, index) => <div key={index} className={`text-xl md:text-2xl font-heading font-bold tracking-tight ${partner.highlight ? 'text-ucensys-teal' : 'text-text-secondary'}`} data-id="element-281">
              {partner.name}
            </div>)}
        </div>
      </div>
    </section>;
}